import React from 'react';
import { Modal } from 'antd';
import { FaCheck, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';

const ThankYouModal = ({ isOpen, setThankYouModalOpen }) => {
    const navigate = useNavigate();
    const handleCancelHome = () => {
        navigate("/holiday");
    };

    return (
        <Modal
            closable={{ 'aria-label': 'Custom Close Button' }}
            open={isOpen}
            onOk={() => setThankYouModalOpen(true)}
            onCancel={handleCancelHome}
            className="thankyou_cntr text-center"
            footer={null}
        >
            <div>
                <FaCheck className="icon" />
                <h1 className="mb-2">Thank You</h1>
                <p className="mb-2"><b>Your form was successfully submitted!</b></p>
                <p className="mb-1">Our representative will be in touch with you within 24 hours.</p>
                <p className="mb-2">
                    Visit our website{' '}
                    <a href="https://https://superbworldtrip.com/" target="_blank" rel="noopener noreferrer" className="text-primary fw-bold">
                        https://superbworldtrip.com
                    </a>{' '}
                    to get detailed information.
                </p>
                <p className="mb-4 d-flex align-items-center gap-1">
                    For further inquiries,{' '}
                    <a href="tel:+918287938514"><FaPhoneAlt /></a> or{' '}
                    <a target="_blank" rel="noopener noreferrer" href="https://api.whatsapp.com/send/?phone=%2B8287938514&text&app_absent=0">
                        <FaWhatsapp />
                    </a>{' '}
                    on{' '}
                    <a href="tel:+918287938514" className="text-primary fw-bold">8287938514</a>.
                </p>
                <Link to="/holiday" className="btn btn-primary px-4" aria-label="Back to Home">
                    Back to Home
                </Link>
            </div>
        </Modal>
    );
};

export default ThankYouModal;